import { render } from "./CheckRegisterTable.vue?vue&type=template&id=f710ff9e"
import script from "./CheckRegisterTable.vue?vue&type=script&lang=js"
export * from "./CheckRegisterTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__